import type { OnboardingV1OnboardingSurveyRole } from '@spotify/confidence-graphql';

import type { SurveyAnswers } from '../../config/onboardingSurvey';

export const OTHER_ROLE = '__other__';

export type SurveyRoleSelection =
  | OnboardingV1OnboardingSurveyRole
  | typeof OTHER_ROLE;

export type SurveyFormValues = {
  role?: SurveyRoleSelection;
  customRole?: string;
};

export const isRoleAnswered = ({
  role,
  customRole,
}: SurveyFormValues): boolean =>
  role === OTHER_ROLE ? Boolean(customRole?.trim()) : role !== undefined;

export const toSurveyAnswers = ({
  role,
  customRole,
}: SurveyFormValues): SurveyAnswers =>
  role === OTHER_ROLE ? { customRole: customRole?.trim() } : { role };
